import classNames from 'classnames';
import { useRouter } from 'next/router';

import { ArrowRight } from '@/icons/index';

import styles from './GoBack.module.scss';

const GoBack = ({ children, goBack, className }) => {
  const router = useRouter();
  return (
    <button
      aria-label='Bakcell'
      onClick={goBack || router.back}
      className={classNames([styles.goBack, className])}
      itemScope
      itemType='http://schema.org/Thing'
    >
      <ArrowRight width={16} />
      <span>{children}</span>
    </button>
  );
};

export default GoBack;
